module.exports = __webpack_public_path__ + "r-v3/img/virtual_background_inside_03.85f67dc6.jpg";